import axiosInstance from "./AxiosInstance";

export function getDiseases(pagination, pageid,search_by = "", search_keyword = "", sort_by = "",sort_order = "") {
  return axiosInstance.post("/admin/diseaseList", {
    pagination, pageid ,search_by, search_keyword, sort_by, sort_order
  });
}

export function createDisease(diseaseData) {
  return axiosInstance.post("/admin/addDisease", diseaseData);
}

export function updateDisease(diseaseData) {
  return axiosInstance.post(`/admin/editDisease`, {
    ...diseaseData,
  });
}

export function deleteDisease(diseaseId) {
  return axiosInstance.post(`/admin/deleteDisease`, { disease_id: diseaseId });
}

export function formatDiseases(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((disease) => ({
      ...disease,
      disease_id: disease.disease_id || disease._id || disease.id,
    }));
  }

  let diseases = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      diseases.push({
        ...responseData[key],
        disease_id:
          responseData[key].disease_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return diseases;
}
